import { ApmRumContextType } from '@wsb/advanced-apm-rum';
import { getCookie } from './getCookie';

export async function validateAuth(
  rumClient: ApmRumContextType,
  rootDomain: string,
  endpoint: string
) {
  const timestamp = Number(getCookie('info_idp_vat_time'));
  const now = Date.now();
  const delta = now - timestamp;
  const nearlyFourMinsInMS = 230000; // 3 min 50 sec (60 * 3 + 50) * 1000

  if (delta < nearlyFourMinsInMS || !rumClient) {
    return;
  }
  const currentTransaction =
    rumClient?.getCurrentTransaction?.() ??
    rumClient?.startTransaction?.(`${endpoint}`, 'validateAuth');

  currentTransaction?.addLabels({ manualHeartbeatCheck: true });

  const data = { infotoken: 'true', realm: 'idp' };
  const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };
  const fetchArgs = {
    method: 'POST',
    headers: headers,
    body: JSON.stringify(data),
    credentials: 'include' as RequestCredentials
  };

  try {
    return await fetch(`https://sso.${rootDomain}/v1/api/token/ui_heartbeat`, fetchArgs);
  } finally {
    currentTransaction?.end();
  }
}
